import { css } from '@emotion/react'
import { CSSProperties, SyntheticEvent, memo } from 'react'
import { useModelColor } from '../../Hooks/useModelColor'

interface ModelNameProps {
    color: string
    isAnonymous?: boolean
    name: string
    modelId: number
    styleOverrides?: CSSProperties
    onClick?: (e: SyntheticEvent) => void
}

const containerStyles = css({
    alignItems: 'center',
    fontWeight: 'bold',
    display: 'flex',
    flexShrink: 0,
    flexGrow: 0,
})
const nameStyles = css({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
})

const ModelName = memo((props: ModelNameProps) => {
    const {
        styleOverrides = {},
        isAnonymous,
        color,
        name,
        onClick,
        modelId,
    } = props
    const modelColor = useModelColor(color)
    const resolvedName = isAnonymous ? name.split('_')[0] : name

    return (
        <div
            data-testid="ModelTile__Name"
            css={containerStyles}
            style={{
                color: modelColor,
                ...styleOverrides,
            }}
            id={`name-${modelId}`}
        >
            <span onClick={onClick} css={nameStyles}>
                {resolvedName}
            </span>
        </div>
    )
})

export default ModelName

export { ModelName }
